export default __webpack_public_path__ + "static/media/support.08ddb687.svg";